// Configurazione centrale API con supporto a runtime override.
// Ordine di precedenza BASE_URL:
// 1. window.__APP_CONFIG__.BASE_URL (runtime-config.js modificabile post build)
// 2. process.env.REACT_APP_API_BASE_URL (variabile di ambiente in fase di build)
// 3. DEFAULT_BASE_URL (fallback hardcoded)

const DEFAULT_BASE_URL = "http://localhost:8000";

function resolveBaseUrl() {
  let fromRuntime;
  if (
    typeof window !== "undefined" &&
    window.__APP_CONFIG__ &&
    window.__APP_CONFIG__.BASE_URL
  ) {
    fromRuntime = window.__APP_CONFIG__.BASE_URL;
  }
  const fromEnv =
    typeof process !== "undefined"
      ? process.env.REACT_APP_API_BASE_URL
      : undefined;
  const chosen = fromRuntime || fromEnv || DEFAULT_BASE_URL;
  // Normalizza togliendo trailing slash multipli
  return chosen.replace(/\/+$/, "");
}

const BASE_URL = resolveBaseUrl();

const API = {
  BASE_URL,
  get ASSETS_URL() {
    return this.BASE_URL;
  },
  get ENDPOINTS() {
    const b = this.BASE_URL;
    return {
      OFFERS: `${b}/api/offers`,
      UPLOAD: `${b}/api/upload`,
      LOGIN: `${b}/api/login`,
      NOVITA: `${b}/api/novita`,
      CONTACT: `${b}/api/contact`,
      SETTINGS: `${b}/api/settings`,
      CATEGORIES: `${b}/api/categories`,
      FAQ: `${b}/api/faq`,
      CONTACTS: `${b}/api/contacts`,
      IMAGES: (category) => `${b}/api/images/${category}`,
    };
  },
};

export default API;
